/**
 * Shared GTwinClient instance for the project surface.
 *
 * Extracted out of `TwinRoute.tsx` so child components (e.g. TwinShell)
 * can reuse the same client without creating a circular import.
 *
 * WP-14 — the singleton now reads the gTwin scene-items feature flag
 * (`VITE_GTWIN_SCENE_ITEMS`) and the default tenant id
 * (`VITE_DEFAULT_TENANT`) from `import.meta.env`, so flipping the flag
 * at build time switches the entire app to the real platform backend
 * without touching consumer call sites.
 */

import { GTwinClient } from '@/sdk-stub/gtwin-sdk';

function defaultGtwinApiBase(): string {
  const fromEnv =
    typeof import.meta !== 'undefined' ? import.meta.env?.VITE_GTWIN_API_URL : undefined;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv);
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/gtwin-api/`;
  }
  // Valid absolute URL for SSR / Node (vitest without jsdom window).
  return 'http://127.0.0.1:5173/gtwin-api/';
}

function defaultTenantId(): string | undefined {
  if (typeof import.meta === 'undefined') return undefined;
  const raw = import.meta.env?.VITE_DEFAULT_TENANT;
  return raw && String(raw).trim() ? String(raw) : undefined;
}

export const gtwinClient = new GTwinClient({
  baseUrl: defaultGtwinApiBase(),
  defaultTenantId: defaultTenantId(),
  sceneItemsMode:
    typeof import.meta !== 'undefined' && import.meta.env?.VITE_GTWIN_SCENE_ITEMS === 'mock'
      ? 'mock'
      : 'real',
});
